import { HttpErrorResponse } from "@angular/common/http";
import { TutorProfile } from "src/app/_models/Tutor";
import { Userprofile } from "src/app/_models/Userprofile";

export interface TutorEditState {
  tutorProfile: TutorProfile;
  userProfile: Userprofile;
  isAllowedToEditTutor: boolean;
  isAllowedToEditTutorLoader: boolean;
  isAllowedToEditTutorError: any;

  updateTutorLoader: boolean;
  updateTutorResult: Userprofile;
  updateTutorError: HttpErrorResponse;

  isTutorProfileStored: boolean;
}

export const initialTutorEditState: TutorEditState = {    
  tutorProfile: null,
  userProfile: null,
  isAllowedToEditTutor: null,
  isAllowedToEditTutorLoader: false,
  isAllowedToEditTutorError: null,

  updateTutorLoader: false,
  updateTutorResult: null,
  updateTutorError: null,

  isTutorProfileStored: false,
}